module.exports = __webpack_public_path__ + "img/37.like.abd65009.svg";